import { OrderDirection } from "_shared/_api/ordering/order-direction";
import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { FeeScheduleTemplateOrderField } from "work/fee-schedule-templates/_api/queries/contracts/ordering/fee-schedule-template-order-parameters";
import { z } from "zod";

export type FeeScheduleTemplateOrderParameters = z.infer<
  typeof FeeScheduleTemplateOrderSchema.FeeScheduleTemplateOrderZ
>;

export default class FeeScheduleTemplateOrderSchema {
  public static readonly FeeScheduleTemplateOrderZ = z
    .object({
      orderBy: z.enum(FeeScheduleTemplateOrderField).optional(),
      orderDir: z.enum(OrderDirection).optional(),
    })
    .optional();

  public static create(values: FeeScheduleTemplateOrderParameters): FeeScheduleTemplateOrderParameters {
    return parseOrThrow(FeeScheduleTemplateOrderSchema.FeeScheduleTemplateOrderZ, values, {
      logError: true,
      schemaName: "FeeScheduleTemplateOrderSchema",
      operation: "create",
      payloadSample: values,
    });
  }
}
